import apiPrd from './apiPrd'


const UserService = {
  async fetchUser() {
    const res = await apiPrd.get('/user/info')
    return res.data
  },
  async saveUserPushToken(playerId) {
    const res = await apiPrd.get(`/transporter/onesignal/bind?playerId=${playerId}`)
    return res.data
  },
}

export default UserService
